import { render, staticRenderFns } from "./Produzione.vue?vue&type=template&id=2fc797d6&"
import script from "./Produzione.vue?vue&type=script&lang=js&"
export * from "./Produzione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports